import { HttpParams, httpResource } from '@angular/common/http';
import { computed, runInInjectionContext } from '@angular/core';
import { toObservable } from '@angular/core/rxjs-interop';
import { filter } from 'rxjs';
import { map } from 'rxjs/operators';
import { widgetHttpHeader } from 'scw-digital-boards-widgets';
import { oeeContext } from '../../../../core/interceptors/api-interceptor.interceptor';
import { IBaseResponse } from '../../../../utilities/http-utilities.service';
import { AdvancedFilterApiMatcher } from './advanced-filter-api-matcher';

interface ILine {
  id: number;
  title: string;
  siteId: number;
}

export class LineAdvancedFilterApiMatcher extends AdvancedFilterApiMatcher {
  public override idValidationResource = runInInjectionContext(this.injector, () =>
    httpResource<IBaseResponse<ILine>>(() => ({
      context: oeeContext,
      headers: widgetHttpHeader,
      method: 'GET',
      params: new HttpParams().set('fields', 'id,title,siteId'),
      reportProgress: true,
      url: `lines/${this.id}`,
    })),
  );

  public readonly data$ = runInInjectionContext(this.injector, () =>
    toObservable(this.idValidationResource.value).pipe(
      filter(Boolean),
      map(({ data }) => data),
    ),
  );
  public override label = computed(() => {
    return this.idValidationResource.status() === 'resolved'
      ? (this.idValidationResource.value()?.data.title ?? '...')
      : '...';
  });
}
